//------------------------------------------------------------------------------
// BFA10102G 共架申込 基本情報
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {
  PositiveButton,
  StandardButton,
} from '@/components/atoms/Buttons/PositiveButton';

/**
 * 操作パネル
 */
function OperationPanel({
  orderNo,
  savable,
  deletable,
  navigate,
  handleSave,
  handleDelete,
}) {

  // 機器設備ボタン
  const handleSetubi = () => {
    console.info(`機器設備 order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10103g/' + orderNo.path());
    }
  }

  // 通信設備ボタン
  const handleTusin = () => {
    console.info(`通信設備 order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10104g/' + orderNo.path());
    }
  }

  // 戻る - 共架申込一覧画面へ
  const handleBack = () => {
    navigate('/bfa10101g');
  }

  //----------------------------------------------------------------------------
  // 描画
  //----------------------------------------------------------------------------
  // 画面遷移可否
  const navigatable = orderNo?.valid();

  // 操作パネル描画
  return (
    <Grid container spacing={1}
      sx={{
        mt: 1,
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      {/* 通信設備 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          size="large"
          disabled={!navigatable}
          onClick={handleTusin}
        >
          <span>通信設備</span>
        </PositiveButton>
      </Grid>

      {/* 機器設備 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          size="large"
          disabled={!navigatable}
          onClick={handleSetubi}
        >
          <span>機器設備</span>
        </PositiveButton>
      </Grid>

      {/* 一時保存 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          startIcon={<SaveAltIcon />}
          size="large"
          disabled={!savable}
          onClick={handleSave}
        >
          <span>一時保存</span>
        </PositiveButton>
      </Grid>

      {/* 削除 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          startIcon={<DeleteOutlineIcon />}
          size="large"
          disabled={!deletable}
          onClick={handleDelete}
        >
          <span>削除</span>
        </PositiveButton>
      </Grid>

      {/* 戻る */}
      <Grid item>
        <StandardButton
          variant="contained"
          size="large"
          startIcon={<KeyboardReturnIcon />}
          onClick={handleBack}
        >
          <span>申込一覧に戻る</span>
        </StandardButton>
      </Grid>
    </Grid>
  );
}

// プロパティ
OperationPanel.propTypes = {
  orderNo:   PropTypes.object,  // 申込番号
  savable:   PropTypes.bool,    // 保存可能
  deletable: PropTypes.bool,    // 削除可能

  // ルーティング
  navigate: PropTypes.func,

  // イベントハンドラー
  handleSave:   PropTypes.func.isRequired,    // 一時保存
  handleDelete: PropTypes.func.isRequired,    // 削除
};

// エクスポート
export default OperationPanel;
